import { styled } from '@mui/system';

const PartnerLogo = styled('img')({});

export { PartnerLogo };
